"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTypeAdjustmentTypes = void 0;
exports.AssetTypeAdjustmentTypes = ['exact', 'multiply'];
//# sourceMappingURL=asset.types.js.map